import React, { useState, useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import ItemsCategories from "../../components/ItemsCategories/ItemsCategories";
import { CarouselModel } from "../../models/carousel.model";
import { SectionDataModel } from "../../models/sections.model";
import axios from "axios";
import {
  HOME_PAGE_HERO_BANNER_CAROUSELS,
  ROUTE_FUNDRAISING,
  REACT_APP_CLOUD_FRONT,
  CATERING_CAFE_ZUPAS_URL,
  ROUTE_FAQ,
} from "../../constants";
import Spinner from "../../components/Spinner/Spinner";
import NewFooter from "../../components/Footer/NewFooter";
import UserSelections from "../../components/UserSelections/UserSelections";
import { useAuthState } from "../../context/UserAuthentication/context";
import * as CONSTANT from "../../constants";
import HomePageBanner from "../../components/HeroBannerNew/HomePageBanner";
import HomeLoyaltyGrid from "./HomeLoyaltyGrid/HomeLoyaltyGrid";
import PeakOurFridge from "./OurKitchen/PeakOurFridge";
import HomeCards from "./HomeCards/HomeCards";
import { CARDS_DATA } from "./HomeCards/HomeCardsData";
import { Container } from "react-bootstrap";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";

interface carouselStyle {
  btnText?: string;
  subTitle?: string;
  btn_Class?: string;
  banner_des_clr?: string;
  btn_controller?: string;
  btn_link?: string;
}
const HomeContainer: React.FC<RouteComponentProps> = ({ history }) => {
  const isItMobile = useCheckMobileScreen();
  const { authInfo } = useAuthState();
  const isUserLogin = authInfo.type !== CONSTANT.GUEST_USER;
  const [isLoading, setLoading] = useState<boolean>(false);
  const [moboImages, setmoboImages] = React.useState(false);
  // const [items, setItems] = useState<Item[]>([]);

  const [CardGrid_data] = useState<SectionDataModel>({
    section_title: "Wholesome Hosting",
    screen_name: "home_screen",
    section_title_sty: "text-uppercase",
    section_details_sty: "font-Cls f-sm-only-s24 ls-normal",
    column1_controller: " ",
    section_details:
      "Exactly what meetings and parties need to taste and feel their best. We make it easy.",
    image_shape: `${REACT_APP_CLOUD_FRONT}/images/Catering/flowerShape.svg`,
    image_shape_position: "align-items-end mb-lg-n4 ms-lg-4",
    main_image: `${REACT_APP_CLOUD_FRONT}/images/Home/Wholesome_Hosting_d`,
    mobo_image: `${REACT_APP_CLOUD_FRONT}/images/Home/wholesome-mobo-image`,
    column2_controller: "text-center text-md-start",
    overlay_clr: "bg-clr-dark-blue",
    button_class: "dark-blue",
    button_text: "ORDER CATERING",
    button_link: CONSTANT.CATERING_CAFE_ZUPAS_URL,
    image_alt_name: "wholesome hosting",
  });
  const [CardGrid2_data] = useState<SectionDataModel>({
    image_shape: `${REACT_APP_CLOUD_FRONT}/images/icons/wave-shape-new.svg`,
    image_shape_position:
      "align-items-start align-items-lg-end pb-5 ms-lg-3 ms-n4",
    section_title: "Foods for funds",
    section_title_sty: "text-uppercase",
    section_details_sty: "font-Cls f-sm-only-s24 ls-normal",
    main_image: `${REACT_APP_CLOUD_FRONT}/images/Home/home-fundraiser_d`,
    mobo_image: `${REACT_APP_CLOUD_FRONT}/images/Home/food-and-funds-mobo-image`,
    section_details:
      "We’ve never met a good cause we couldn’t cook for. See what we can do for yours.",
    overlay_clr: "bg-clr-highland-green",
    button_class: "green",
    button_text: "FUNDRAISER NIGHTS",
    button_link: ROUTE_FUNDRAISING,
    screen_name: "home_screen",
    column2_controller: "text-center text-md-start",
    column1_controller: " ",
    column_inverse: " ",
    order_controller: "order-0 order-lg-1",
    image_alt_name: "home fundraiser",
  });
  useEffect(() => {
    var x = window.matchMedia("(min-width: 768px)");
    if (x.matches) {
      setmoboImages(true);
    } else {
      setmoboImages(false);
    }
  }, []);

  const handleCardsClick = (index, item) => {
    if (item === CATERING_CAFE_ZUPAS_URL) {
      window.location.href = CATERING_CAFE_ZUPAS_URL;
    } else if (item === ROUTE_FAQ && isUserLogin) {
      history.push(CONSTANT.ROUTE_REWARDS_REDEEM);
    } else {
      history.push(item);
    }
  };
  return isLoading ? (
    <Spinner lightBg={true}></Spinner>
  ) : (
    <>
      <Container fluid className="px-lg-5">
        <HomePageBanner />
      </Container>
      <ItemsCategories />
      <Container fluid className="px-lg-5">
        <HomeLoyaltyGrid />
        <PeakOurFridge />
        <div className={`row ${isItMobile ? 'gx-3 cz-px-5 gutter-space cz-mt-20': 'cz-mt-30'}  cz-mb-30 cz-mb-sm-0 other-pages-card`}>
          {CARDS_DATA.map((data, i) => {
            return (
              <div
                className={`col-md-4 ${
                  i === 0 ? `col-12 ${isItMobile && "order-3 "} ` : "col-6"
                }
              ${isItMobile && "cz-mb-20"}`}
              >
                <HomeCards
                  image={data.image}
                  title={data.title}
                  mobileImage= {data.mobileImage}
                  description={data.description}
                  color={data.color}
                  handleClick={() => {
                    handleCardsClick(i, data.link);
                  }}
                />
              </div>
            );
          })}
        </div>
      </Container>
      <NewFooter sectionController=" pt-0" textColor="color-yellow" />
      {authInfo.type !== CONSTANT.GUEST_USER ? <UserSelections /> : ""}
    </>
  );
};

export default withRouter(HomeContainer);
